import { Box, Button, Typography, makeStyles, createStyles, Theme, useTheme } from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';
import { FiMessageCircle } from 'react-icons/fi';

import { monochrome } from '../../theme/styles';

interface Props {
  onActivateClick?: () => void;
  canActivate?: boolean;
}

// Floating promo card shown to employers without a messaging subscription
export const ChatActivateMessagingBanner: React.FC<Props> = ({ onActivateClick, canActivate = true }) => {
  const theme = useTheme();
  const classes = useStyles();

  return (
    <Box className={classes.card}>
      <Box className={classes.iconCircle}>
        <FiMessageCircle size={18} color={theme.palette.background.paper} />
      </Box>

      <Box className={classes.textBox}>
        <Typography className={classes.title}>Turn messaging on.</Typography>
        <Typography className={classes.subtitle}>
          {canActivate
            ? 'Click here to subscribe to Vyce Messaging so your teams and locations can chat through Vyce — chats build themselves automatically.'
            : 'Please contact your company Admin to activate Vyce Messaging so your teams and locations can chat through Vyce — chats build themselves automatically.'}
        </Typography>
      </Box>

      {canActivate && (
        <Button variant="contained" color="primary" onClick={onActivateClick}>
          Activate now
        </Button>
      )}
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) => {
  const dark = theme.palette.type === 'dark';
  return createStyles({
    card: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gridGap: 12,
      width: '100%',
      maxWidth: 640,
      padding: '12px 20px',
      borderRadius: 16,
      border: `1px solid ${alpha(theme.palette.primary.main, dark ? 0.32 : 0.16)}`,
      // Opaque: solid paper base with the primary tint layered on top, so the chat pattern doesn't show through
      backgroundColor: theme.palette.background.paper,
      backgroundImage: `linear-gradient(${alpha(theme.palette.primary.main, dark ? 0.16 : 0.08)}, ${alpha(
        theme.palette.primary.main,
        dark ? 0.16 : 0.08
      )})`,
      boxShadow: theme.shadows[3],
    },
    iconCircle: {
      width: 40,
      height: 40,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.palette.primary.main,
      flexShrink: 0,
    },
    textBox: {
      flex: 1,
      minWidth: 240,
    },
    title: {
      fontWeight: 600,
      fontSize: '15px',
      color: theme.palette.type === 'dark' ? monochrome.light : monochrome.dark,
    },
    subtitle: {
      fontSize: '13px',
      color: theme.palette.text.secondary,
      marginTop: 2,
    },
  });
});
